<template>
  <div class="group/inputShow relative border border-dashed border-blueG0 border-opacity-15 rounded-xl">
    <i
      v-if="file"
      @click="removeFile"
      class="hidden group-hover/inputShow:block el-icon-close z-10 absolute top-2.5 right-2.5 cursor-pointer mr-px text-xl text-white leading-none"
    />
    <div class="group/uploader cursor-pointer w-full h-full" @click="() => $refs.fileInput.click()">
      <input ref="fileInput" class="hidden" type="file" accept=".pdf, .jpg, .jpeg" @change="handleFileChange" />
      <div
        :class="file ? null : 'bg-blueG0 bg-opacity-2 group-hover/uploader:bg-opacity-8'"
        class="relative w-full h-full flex flex-col items-center justify-center"
      >
        <div v-if="file" class="absolute top-0 bottom-0 left-0 right-0 w-full h-full rounded-lg overflow-hidden">
          <div
            v-if="isMobileDevice() && isPdfFile"
            class="w-full h-full rounded-lg bg-grayG0 bg-opacity-10 flex items-center justify-center"
          >
            <i class="el-icon-document-checked text-8xl text-greenG0"></i>
          </div>
          <embed v-else-if="isPdfFile" class="w-full h-full" :src="filePreview" />
          <img v-else class="w-full h-full object-contain" :src="filePreview" />
          <div
            :class="file ? 'bg-black bg-opacity-60' : 'bg-blueG0 bg-opacity-15'"
            class="hidden group-hover/inputShow:block pointer-events-none absolute top-0 bottom-0 left-0 right-0 w-full h-full"
          />
        </div>
        <div
          :class="file ? 'hidden group-hover/inputShow:flex' : 'flex'"
          class="z-10 flex-row md:flex-col items-center justify-center gap-1.5"
        >
          <svg-icon iconName="document-add-icon" className="!w-7.5 !h-7.5 text-blueG0" />
          <div
            v-if="placeholder && placeholder.length > 0"
            :class="file ? 'text-white' : 'text-blueG0'"
            class="text-xs text-center"
          >
            {{ $t(placeholder) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mimeType } from '@/constants/fileMimeType';
import { isMobileDevice } from '@/util/getDeviceType';

export default {
  name: 'UploadFileInput',
  props: {
    file: { type: [File, null], default: null },
    onFileChange: { type: Function, required: true },
    placeholder: { type: String, default: '' }
  },
  created() {
    this.isMobileDevice = isMobileDevice;
  },
  computed: {
    filePreview() {
      if (this.file) {
        return URL.createObjectURL(this.file);
      } else {
        return '';
      }
    },
    isPdfFile() {
      return this.file.type.includes(mimeType['.pdf']);
    }
  },
  watch: {
    // To reset file input when change file manually
    file() {
      this.$refs.fileInput.value = '';
    }
  },
  methods: {
    removeFile() {
      this.onFileChange?.(null);
    },
    handleFileChange(event) {
      if (event.target.files?.[0]) {
        this.onFileChange?.(event.target.files?.[0]);
      }
    }
  }
};
</script>
